module.exports = __webpack_public_path__ + "static/media/front_02.cb39f17c.png";